import React from 'react';

import './styles.css';

import WhoWeAre from '../../partials/WhoWeAre/WhoWeAre.js'


const HomeFeatured = (props) => {
  return (
    <React.Fragment>
            
    
    <WhoWeAre 
        who_we_are_title={props?.setting?.home_who_we_are_title}
        who_we_are_subtitle={props?.setting?.home_who_we_are_subtitle}
        who_we_are_content={props?.setting?.home_who_we_are_content}
        who_we_are_image={props?.setting?.home_who_we_are_image}
    />

<div className="container pt-5 home-about-us">
    <div className="featured-boxes featured-boxes-style-3 pt-5 pb-5">
        <div className="row">

            {props?.setting?.home_features_sections?.map((feature, index) => (
                <div className="col-lg-4" key={index}>
                    <div className="featured-box featured-box-primary featured-box-effect-3">
                        <div className="box-content">
                            <i className={`icon-featured ${feature.icon} top-0`} />
                            <h4 className="font-weight-normal text-5 mt-3">{feature.title}</h4>
                            <p className="mb-0">{feature.content}</p>
                        </div>
                    </div>
                </div>
            ))}

        </div>
    </div>

</div>

    </React.Fragment>
  );
};

export default HomeFeatured;
